import { Column, Columns, Stack, TextField } from 'braid-design-system';
import { CodeContainer, InlineCode } from 'scoobie';
import { DividerColumn } from '#src/components/DividerColumn/DividerColumn.tsx';
import { ThemedExample } from '#src/components/ThemedExample/ThemedExample.tsx';

export const AddressMapping = () => (
  <ThemedExample>
    <Columns collapseBelow="tablet" space="gutter">
      <Column>
        <CodeContainer
          code={JSON.stringify(
            {
              address: [
                {
                  city: 'Coober Pedy',
                  postalCode: '5723',
                  countryCode: 'AU',
                  countrySubDivisions: [
                    {
                      type: 'State',
                      value: 'South Australia',
                    },
                  ],
                },
              ],
            },
            null,
            2,
          )}
          language="json"
        />
      </Column>

      <DividerColumn horizontalToVerticalBreakpoint="tablet" />

      <Column>
        <Stack space="large">
          <TextField
            label="City/suburb"
            onChange={() => undefined}
            reserveMessageSpace
            message={<InlineCode>city</InlineCode>}
            value="Coober Pedy"
          />
          <TextField
            label="Postal/ZIP code"
            onChange={() => undefined}
            message={<InlineCode>postalCode</InlineCode>}
            value="5723"
          />
          <TextField
            label="Country"
            onChange={() => undefined}
            message={<InlineCode>countryCode</InlineCode>}
            value="AU"
          />
          <TextField
            label="State/province"
            onChange={() => undefined}
            message={
              <>
                <InlineCode>countrySubDivisions</InlineCode> of type{' '}
                <InlineCode>State</InlineCode>
              </>
            }
            value="South Australia"
          />
        </Stack>
      </Column>
    </Columns>
  </ThemedExample>
);
